import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';
import {ROLES} from "../constants";

const checkRole = role => {
    return [ ROLES.admin, ROLES.socialOperator, ROLES.assistant ].includes(role?.id);
}

const OperatorGuard = ({ children }) => {
    const { user } = useAuth();
    if ( !checkRole(user.role) ) {
        return <Redirect to="/404" />;
    }

    return (
        <>
            {children}
        </>
    );
};

OperatorGuard.propTypes = {
    children: PropTypes.node
};

export default OperatorGuard;
